import React, { createContext, useContext, ReactNode } from 'react';
import { useConfirmService, ConfirmService } from '../services/confirmService';

interface ConfirmContextType extends ConfirmService {}

const ConfirmContext = createContext<ConfirmContextType | undefined>(undefined);

interface ConfirmProviderProps {
  children: ReactNode;
}

export const ConfirmProvider: React.FC<ConfirmProviderProps> = ({ children }) => {
  const confirmService = useConfirmService();

  return (
    <ConfirmContext.Provider value={confirmService}>
      {children}
    </ConfirmContext.Provider>
  );
};

export const useConfirm = (): ConfirmContextType => {
  const context = useContext(ConfirmContext);
  if (context === undefined) {
    throw new Error('useConfirm must be used within a ConfirmProvider');
  }
  return context;
};
